export default __webpack_public_path__ + "BetConstruct-Icons-f90e0824.svg";